'use client';
export { Profile as default } from '../components/profile';
